// import qs from 'qs';
import defaultApi from '@/utils/request';

export default {
  UploadFiles(data) {
    return defaultApi({
      method: 'post',
      url: 'Files/Upload',
      data,
    });
  },

};
